<template>
    <div v-if="isVisible" class="form-item" :class="[isInvalid ? 'is-invalid' : '']">
        <Label :item="item"
               :is-invalid="isInvalid"
               :errors="errors" />

        <div class="scale">
            <div @mouseleave="hover = 0">
                <span
                    v-for="n in Number(item.data.scaleSteps)"
                    :key="n"
                    class=""
                    @mouseenter="hover = n"
                    @click="select(n)">
                    <i :class="[`fa-${item.data.scaleIcon}`, iconStyle(n)]" />
                </span>
            </div>

            <div class="scale-min-label hasi18n" />
            <div class="scale-max-label hasi18n" />
        </div>

        <input type="hidden" :name="item.data.id" :value="selected" />
    </div>
</template>

<script>
import Label from "../components/Label.vue";

import errorMixin from "../mixins/error";
import logicMixin from "../mixins/logic";

export default {
    name: 'Scale',
    components: { Label },
    mixins: [ errorMixin, logicMixin ],
    props: {
        item: {
            type: Object
        }
    },
    data: function() {
        return {
            hover: 0,
            selected: this.item.data.scaledefaultselected ? Number(this.item.data.scaledefaultselected) : null
        };
    },
    methods: {
        select(n) {
            this.selected = n;
        },
        iconStyle(n) {
            if (n <= this.hover) {
                return 'fa';
            }

            return n <= this.selected ? 'fa' : 'far';
        }
    }
};
</script>

<style lang="scss" scoped>
.scale{
    font-size: 1.6rem;

    span {
        font-size: 2.4rem;
        color: var(--primary);
        cursor: pointer;
    }
}
</style>